'use strict';

module.exports = require('./node/');



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/platform/index.js
// module id = 252
// module chunks = 0